// extracted by mini-css-extract-plugin
export default {"article__nav":"ArticleNav_article__nav__mJ1pB","article__link":"ArticleNav_article__link__OKc9n"};